// eslint-disable-next-line no-restricted-imports
import {generatePath as routerGeneratePath} from 'react-router-dom';

export const generatePath: typeof routerGeneratePath = (...args) => {
    return routerGeneratePath(...args) + '/';
};
